import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { SlideComponent } from './slide/slide.component';
import { SlideRouterService } from './slide-router.service';
import { SlideTitleComponent } from './slide-title.component';
import { Location, LocationStrategy, HashLocationStrategy } from '@angular/common';
import { SlideFragmentComponent } from './slide-fragment.component';
import { CodeSlideComponent } from './code-slide/code-slide.component';
import { AceEditorDirective } from 'ng2-ace-editor';
import {HttpClientModule} from '@angular/common/http';
import { CodeExampleComponent } from './code-example/code-example.component';
import { SubSlideFragmentComponent } from './sub-slide-fragment/sub-slide-fragment.component';

@NgModule({
  declarations: [
    AppComponent,
    SlideComponent,
    SlideTitleComponent,
    SlideFragmentComponent,
    CodeSlideComponent,
    AceEditorDirective,
    CodeExampleComponent,
    SubSlideFragmentComponent
  ],
  imports: [
    BrowserAnimationsModule,
    HttpClientModule
  ],
  providers: [
    SlideRouterService,
    Location,
    { provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts